import type { GridColDef } from "@mui/x-data-grid-premium";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import { pageRoutes } from "../../../../routes";
import type { ObjectFieldValues } from "../../../../api/types/objectTypes";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import ObjectsListPage from "../../../entityFields/grid/ObjectsListPage";
import ObjectsListContext from "../../../entityFields/grid/ObjectsListContext";
import UploadDocumentsButton from "../../workflows/workflow-runs/UploadDocumentsButton";
import InvoicesActionsToolbar from "./InvoicesActionsToolbar";
import { InvoicesGridContextProvider } from "./InvoicesGridContext";
import InvoicesGridHeaderToolbar from "./InvoicesGridHeaderToolbar";
import InvoicesGridRowActions from "./InvoicesGridRowActions";

const invoicesActionsColumn: GridColDef<ObjectFieldValues> = {
  field: "actions",
  headerName: "Actions",
  width: 80,
  sortable: false,
  resizable: false,
  align: "right",
  headerAlign: "right",
  cellClassName: "grid-row-actions",
  renderCell: ({ row }) => <InvoicesGridRowActions invoice={row} />,
};

const InvoicesHeaderActions = () => {
  const { refreshRows } = useDefinedContext(ObjectsListContext, "ObjectsListContext");

  return (
    <>
      <InvoicesActionsToolbar />
      <UploadDocumentsButton workflowType="InvoiceProcessing" onWorkflowsStarted={refreshRows} />
    </>
  );
};

const InvoicesPage = () => {
  const [pendingApprovals, fetchError, { fetch: refetchPendingApprovals }] = useFetch(adminApi.getPendingApprovals);

  if (fetchError) {
    logError(fetchError, "[InvoicesPage] getPendingApprovals");
  }

  return (
    <InvoicesGridContextProvider pendingApprovals={pendingApprovals} refetchPendingApprovals={refetchPendingApprovals}>
      <ObjectsListPage
        objectType="Invoice"
        objectDetailsPathPattern={`/:clientCode/${pageRoutes.expenseManagement}/${pageRoutes.invoices}/:id`}
        objectsTitle="Invoices"
        allowCreate
        excelExportConfig={{ relatedObjects: { objectType: "InvoiceLine", label: "Include invoice lines" } }}
        headerActions={<InvoicesHeaderActions />}
        actionsColumn={invoicesActionsColumn}
        selectionActions={<InvoicesGridHeaderToolbar />}
        onTabChange={refetchPendingApprovals}
      />
    </InvoicesGridContextProvider>
  );
};

export default InvoicesPage;
